import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';

import { GroupedItemContextMenu } from '@/shared/features/groups/components/grouped-item-context-menu/grouped-item-context-menu';

// Generic row renderer: shows the move/remove menu for a grouped resource row.
export const GroupedItemContextMenuRenderer: React.FC<ICellRendererParams> = ({
  data,
}) => {
  if (!data?.raw) {
    return null;
  }

  return <GroupedItemContextMenu item={data.raw} />;
};
